import styled from 'styled-components';
import { device } from '../../styles/devices';

export const ButtonContainer = styled.button`
  cursor: pointer;
  display: flex;
  border: none;
  background-color: transparent;
  padding: 12px;
  box-shadow: inset 0 0 0 1px #000000;
`;

export const ArrowsWrapper = styled.div`
  display: flex;
  width: fit-content;
  gap: 8px;
  @media ${device.laptop} {
    gap: 12px;
  }
`;
